module.exports = __webpack_public_path__ + "static/img/币币交易_图2.5435992f.png";